<template>
    <collapsible-block ref="collapsible"
                       :title-text="$t('businessOrders.labels.orderInformation')"
                       class="order-information"
                       preview-only
    >
        <flex-row column-spacing="lg"
                  class="flex--no-wrap order-information__order-comments"
        >
            <div class="col">
                <value-wrapper :label="$t('businessOrders.labels.orderComments')">
                    {{ filteredOrderComments | valueOrDash }}
                </value-wrapper>
            </div>
        </flex-row>

        <div
            v-if="businessOrder.packages.length == 0 && businessOrder.pallets.length == 0"
            class="order-information__sku-table stick-to-modal-sides"
        >
            <table class="table table--stick-to-modal-sides">
                <thead>
                    <tr class="table__header-row">
                        <th class="table__header-cell">
                            {{ $t('businessOrders.labels.sku') }}
                        </th>
                        <th class="table__header-cell">
                            {{ $t('businessOrders.labels.description') }}
                        </th>
                        <th v-if="isLotTrackedOrder"
                            class="table__header-cell"
                        >
                            {{ $t('businessOrders.labels.lotnumber') }}
                        </th>
                        <th v-if="isLotTrackedOrder"
                            class="table__header-cell"
                        >
                            {{ $t('businessOrders.labels.expiration') }}
                        </th>
                        <th class="table__header-cell">
                            {{ $t('businessOrders.labels.quantity') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in businessOrder.items"
                        :key="item.id"
                        class="table__body-row"
                        :class="{'text-error': !item.isInStock || businessOrder.isUnavailableExpiredLotOrder }"
                    >
                        <td class="table__body-cell fixsizes">
                            {{ item.sku | valueOrDash }}
                        </td>
                        <td class="table__body-cell fixsizes">
                            {{ item.description | valueOrDash }}
                        </td>
                        <td v-if="isLotTrackedOrder"
                            class="table__body-cell fixsizes"
                            :class="{'text-error': new Date(item.expirationDate) <= new Date() }"
                        >
                            {{ item.lotNumber | valueOrDash }}
                        </td>
                        <td v-if="isLotTrackedOrder"
                            class="table__body-cell fixsizes"
                            :class="{'text-error': new Date(item.expirationDate) <= new Date() }"
                        >
                            {{ item.expirationDate | date('short') | valueOrDash }}
                        </td>
                        <td class="table__body-cell">
                            {{ item.quantity | valueOrDash }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </collapsible-block>
</template>

<script>
import { $t } from '@/translations';
import CollapsibleBlock from '@/components/layout/CollapsibleBlock';
import { ValueWrapper } from '@/components/form';

export default {
    components: {
        CollapsibleBlock,
        ValueWrapper,
    },
    props: {
        businessOrder: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        filteredOrderComments() {
            if (this.businessOrder.orderComments === null) return '';
            return this.businessOrder.orderComments.replace($t('businessOrders.labels.disposalOrderComment'), '').trim();
        },
        isLotTrackedOrder() {
            return this.businessOrder.items.some(x => x.isUserInitiatedLotOrder);
        },
    },
};
</script>

<style lang="scss" scoped>
.order-information {
    &__order-comments {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    &__sku-table {
        margin-top: 20px;
    }
}

.fixsizes {
    word-break: break-all;
}
</style>
